import { useState } from "react";
import { Modal } from "@/components/ui/modal";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/hooks/useI18n";
import ItineraryStep from "@/lib/builder/ItineraryStep";
import { StepProps } from "@/lib/builder/models/builder.model";
import { ItineraryData } from "@/lib/builder/models/itinerary.model";

interface ItineraryStepModalProps extends Pick<StepProps, 'data' | 'onDataChange' | 'canProceed' | 'setCanProceed'> {
  onClose: () => void;
}

export const ItineraryStepModal = ({
  onClose,
  data,
  onDataChange,
  canProceed,
  setCanProceed,
}: ItineraryStepModalProps) => {
  const { t } = useI18n();
  // Component is mounted/unmounted with the modal — no need for reset logic
  const [localData, setLocalData] = useState<ItineraryData | null>(data ?? null);

  const handleConfirm = () => {
    if (localData) {
      onDataChange(localData);
    }
    onClose();
  };

  return (
    <Modal
      isOpen={true}
      onClose={onClose}
      title={t('itinerary.itineraryDetails')}
      size="lg"
      footer={
        <div className="flex w-full justify-end">
          <Button onClick={handleConfirm}>{t('common.confirm')}</Button>
        </div>
      }
    >
      <div>
        {localData && (
          <ItineraryStep
            data={localData}
            onDataChange={(newData) => setLocalData((prev) => prev ? prev.update(newData) : prev)}
            onImmediateDataChange={(newData) => {
              setLocalData((prev) => prev ? prev.update(newData) : prev);
              onDataChange(newData);
            }}
            onNext={handleConfirm}
            onPrevious={() => {}}
            onSave={() => {}}
            onCancel={onClose}
            canProceed={canProceed}
            setCanProceed={setCanProceed}
            compact
          />
        )}
      </div>
    </Modal>
  );
};
